"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatSeconds = formatSeconds;
exports.formatSecondsToLabel = formatSecondsToLabel;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function formatSeconds(seconds) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mm:ss';
  var isMinus = 0 > seconds;
  var absSeconds = Math.abs(seconds);

  var result = _moment["default"].utc(absSeconds * 1000).format(format);

  return "".concat(isMinus ? '-' : '').concat(result);
}

function formatSecondsToLabel(seconds) {
  var _formats;

  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dd:hh:mm';
  var absMiliSeconds = Math.abs(seconds) * 1000;

  var duration = _moment["default"].duration(absMiliSeconds);

  var formats = (_formats = {}, _defineProperty(_formats, 'dd', _react["default"].createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "{days}",
    id: "GameServer.CSGame.Trainer/timerInOnlyDays",
    values: {
      days: duration.days()
    }
  })), _defineProperty(_formats, 'dd:hh:mm', _react["default"].createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "{days} days {hours} hours {minutes} minutes",
    id: "GameServer.CSGame.Trainer/timerInOnlyDays",
    values: {
      days: duration.days(),
      hours: duration.hours(),
      minutes: duration.minutes()
    }
  })), _defineProperty(_formats, 'hh', _react["default"].createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "{hours}",
    id: "GameServer.CSGame.Trainer/timerInOnlyHours",
    values: {
      hours: duration.hours()
    }
  })), _defineProperty(_formats, 'hh:mm', _react["default"].createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "{hours} hours {minutes} minutes",
    id: "GameServer.CSGame.Trainer/timerInHours",
    values: {
      hours: duration.hours(),
      minutes: duration.minutes()
    }
  })), _defineProperty(_formats, 'mm', _react["default"].createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "{minutes}",
    id: "GameServer.CSGame.Trainer/timerInOnlyMinutes",
    values: {
      minutes: duration.minutes()
    }
  })), _formats);
  var result = formats[format];

  if (!formats[format]) {
    result = formats['dd:hh:mm'];
  }

  return result;
}